import { observer } from "mobx-react-lite";
import {
  type PropsWithChildren,
  createContext,
  useState,
  useContext,
} from "react";

import { type WorkoutData, WorkoutEditStore } from "./WorkoutEditStore";

export interface WorkoutEditContextValue {
  store: WorkoutEditStore;
}

export const WorkoutEditContext = createContext<WorkoutEditContextValue>(null!);

export interface WorkoutEditStoreProviderProps extends PropsWithChildren {
  workout: WorkoutData;
}

export const WorkoutEditStoreProvider = observer(
  function WorkoutEditStoreProvider(props: WorkoutEditStoreProviderProps) {
    const [value] = useState(() => {
      return { store: new WorkoutEditStore(props.workout) };
    });

    return (
      <WorkoutEditContext.Provider value={value}>
        {props.children}
      </WorkoutEditContext.Provider>
    );
  },
);

export function useWorkoutEditContext() {
  return useContext(WorkoutEditContext);
}

export function useWorkoutEditStore() {
  return useWorkoutEditContext().store;
}
